import { Utils } from '@genial/utils';
import * as zod from 'zod';

export const validateFundRedemptionValueApplied = (minValue: number, maxValue: number) => {
  const RedemptionFormSchema = zod.object({
    redemptionValue: zod
      .string({
        required_error: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) >= Number(minValue?.toFixed(2) || 0), {
        message: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) <= maxValue, {
        message: `Valor máximo ${Utils.Mask.Money(maxValue)}`,
      }),
  });

  return RedemptionFormSchema;
};

export type RedemptionFormData = zod.infer<ReturnType<typeof validateFundRedemptionValueApplied>>;
